import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Toolbar,
  Button,
  TextField,
  Autocomplete,
  Chip,
  Avatar,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import pdf from "../../assets/icons/pdf.png";
import { getAllDisabilities, approveDisability } from "../../../store/recruitment/actions";
import { getDisabilities } from "../../../store/structure/actions";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NoRecordMessage from "../../common/components/NoRecordMessage";
import TableSkeleton from "../../common/components/TableSkeleton";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import BackdropLoader from "../../common/components/BackdropLoader";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";

const AllDisabilities = (props) => {
  const { allDisabilities, getAllDisabilities, disabilities, getDisabilities, approveDisability } =
    props;
  const defaultIds = "";
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 15
  );
  const [totalRequests, setTotalRequests] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);

  const [filterDisability, setFilterDisability] = useState({
    id: "",
    name: "All",
  });

  useEffect(() => {
    getDisabilities();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_ALL_DISABILITIES",
      data: [],
    });
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
      disabilityId: filterDisability?.id || defaultIds,
    };

    getAllDisabilities(query, setTotalRequests, setIsLoading);
  }, []);

  const onSearch = () => {
    if (!searchTerm) return false;
    const query = {
      searchTerm: searchTerm,
      page: 1,
      size: itemPerPage,
      disabilityId: filterDisability?.id || defaultIds,
    };
    getAllDisabilities(query, setTotalRequests, setIsLoading);
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);
    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
      disabilityId: filterDisability?.id || defaultIds,
    };
    getAllDisabilities(query, setTotalRequests, setIsLoading1);
  };

  return (
    <>
      <div className="row mx-0">
        <div className="col-12 mt-2">
          <div className="pr-3">
            <AppBar
              position="static"
              elevation={0}
              style={{ overflow: "hidden" }}
              className="app-bar w-100"
            >
              <Toolbar className="row">
                <div className="col-lg-7">
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    className="text-uppercase"
                  >
                    <span style={{ color: "rgb(7, 142, 206)" }}>
                      {searchTerm
                        ? "Filtered disabilities"
                        : "All disabilities"}
                      ({totalRequests})
                    </span>
                  </Typography>
                </div>

                <div className="col-lg-5">
                  <div className="d-flex justify-content-end  align-items-end">
                    <Autocomplete
                      sx={{ width: 400 }}
                      className="mr-2"
                      size="small"
                      id="filterDisability"
                      defaultValue={null}
                      value={filterDisability || null}
                      options={disabilities}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, filterDisability) => {
                        const query = {
                          searchTerm: "",
                          page: currentPage,
                          size: itemPerPage,
                          disabilityId: filterDisability?.id || defaultIds,
                        };
                        setFilterDisability(filterDisability);
                        getAllDisabilities(
                          query,
                          setTotalRequests,
                          setIsLoading1
                        );
                      }}
                      getOptionLabel={(option) => option.name}
                      renderOption={(props, filterDisability) => (
                        <Box
                          component="li"
                          {...props}
                          key={filterDisability.id}
                        >
                          {filterDisability.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{
                            width: "100%",
                            height: "35px!important",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "1px!important",
                          }}
                          {...params}
                          label="Filter By Level"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "filterDisability", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                    <div className="d-flex justify-content-end  align-items-end">
                      <SearchBox
                        onKeyPress={() => onSearch()}
                        onSearch={(search) => {
                          setSearchTerm(search);

                          if (!search) {
                            const currentPage = 1;
                            setCurrentPage(currentPage);
                            const query = {
                              searchTerm: "",
                              page: currentPage,
                              size: itemPerPage,
                              disabilityId: filterDisability?.id || defaultIds,
                            };
                            getAllDisabilities(
                              query,
                              setTotalRequests,
                              setIsLoading1
                            );
                          }
                        }}
                        placeholder="Search…"
                      />
                      <Button
                        disabled={!searchTerm}
                        onClick={() => onSearch()}
                        variant="contained"
                        size="small"
                        disableElevation
                        className="mr-2 "
                        style={{
                          borderRadius: "8px",
                          height: "38px",
                          border: `1px solid rgb(7, 142, 206)`,
                          color: "#fff",
                          alignItems: "center",
                          fontSize: ".75rem",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textTransform: "initial",
                          backgroundColor: "rgb(7, 142, 206)",
                          marginLeft: "5px",
                          "&:hover": {
                            backgroundColor: "#f0f2f5",
                          },
                        }}
                      >
                        <span className="material-icons">search</span>GO
                      </Button>
                    </div>
                  </div>
                </div>
              </Toolbar>
            </AppBar>

            <table className="table table-striped table-hover table-sm  fixTableHead">
              <thead>
                <tr style={{ backgroundColor: "#f0f2f5" }}>
                  <th scope="col">#</th>

                  <th scope="col" className="text-left py-2">
                    Names
                  </th>
                  <th scope="col" className="text-right">
                    Phone
                  </th>

                  <th scope="col" className="text-right">
                    Email
                  </th>
                  <th scope="col" className="text-right">
                    Level
                  </th>
                  <th scope="col" className="text-right">
                    Disability
                  </th>
                  <th scope="col" className="text-right">
                    Status
                  </th>
                  <th scope="col" className="text-right"></th>
                </tr>
              </thead>
              {isLoading ? (
                <TableSkeleton cols={8} />
              ) : (
                <tbody>
                  <BackdropLoader isLoading={isLoading1} />
                  {allDisabilities.map((userDisability, index) => (
                    <AllDisabilityCard
                      key={userDisability.id}
                      index={index}
                      userDisability={userDisability}
                      approveDisability={approveDisability}
                    />
                  ))}
                </tbody>
              )}
            </table>
            <NoRecordMessage
              isEmpty={!allDisabilities.length && !isLoading}
              title={"No record found"}
            />
            {!isLoading && (
              <div
                className="d-flex justify-content-center  align-items-center"
                style={{ overflow: "hidden" }}
              >
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    // marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRequests / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-info btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-info btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                {!!allDisabilities.length && (
                  <select
                    className="custom-select custom-select-sm ml-2"
                    style={{ width: "100px" }}
                    value={itemPerPage}
                    onChange={(event) => {
                      const itemPerPage = +event.target.value;
                      window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                      setItemPerPage(itemPerPage);
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                        disabilityId: filterDisability?.id || defaultIds,
                      };
                      getAllDisabilities(query, setTotalRequests, setIsLoading);
                    }}
                  >
                    {[10, 15, 20, 50, 100].map((item, index) => (
                      <option key={index}>{item}</option>
                    ))}
                  </select>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user, loading, allDisabilities, disabilities }) => {
  return { user, loading, allDisabilities, disabilities };
};
export default connect(mapStateToProps, {
  getAllDisabilities,
  getDisabilities,
  approveDisability
})(AllDisabilities);

const AllDisabilityCard = (props) => {
  const { userDisability, index, approveDisability } = props;
  const [showModal, setShowModal] = useState(false);
  const [onViewDocument, setOnViewDocument] = useState(false);
  const [document, setDocument] = useState(null);
  return (
    <>
      <tr>
        <th scope="row" style={{ backgroundColor: "#f0f2f5" }}>
          {index + 1}
        </th>
        <td className="text-left">
          {" "}
          {userDisability.lastName} {userDisability.firstName}
        </td>
        <td className="text-right"> {userDisability.phoneNumber}</td>
        <td className="text-right"> {userDisability.email}</td>
        <td className="text-right"> {userDisability.disabilityLevel}</td>
        <td className="text-right"> {userDisability.disability}</td>
        <td className="text-right">
          <span
            className={`badge badge-${
              +userDisability?.isApproved === 0
                ? "warning"
                : +userDisability?.isApproved === 1
                ? "success"
                : "danger"
            } p-1`}
          >
            {+userDisability?.isApproved === 0
              ? "Pending"
              : +userDisability?.isApproved === 1
              ? "Approved"
              : "Rejected"}
          </span>
        </td>
        <td className="text-right">
          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="btn btn-secondary m-2 btn-sm"
          >
            <OpenInNewIcon /> View Details
          </button>
        </td>
        {showModal && (
          <ConfirmationDialog
            size="xl"
            alignContent="left"
            dividers
            title={
              <>
                <div className="pr-5">
                  <span className="text-dark">
                    View {userDisability.disability}
                  </span>
                </div>
              </>
            }
            confirmationDialog={showModal}
            message={
              <>
                <table className="table table-striped table-hover table-sm  fixTableHead">
                  <thead>
                    <tr>
                      <th scope="row" className="p-2">
                        Names
                      </th>
                      <td className="p-2">
                        {userDisability.lastName} {userDisability.firstName}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className="p-2">
                        Phone number
                      </th>
                      <td>{userDisability.phoneNumber}</td>
                    </tr>
                    <tr>
                      <th scope="row" className="p-2">
                        Email
                      </th>
                      <td className="p-2">{userDisability.email}</td>
                    </tr>
                    <tr>
                      <th scope="row" className="p-2">
                        Disability
                      </th>
                      <td className="p-2">{userDisability.disability}</td>
                    </tr>
                    <tr>
                      <th scope="row" className="p-2">
                        Disability Level
                      </th>
                      <td className="p-2">{userDisability.disabilityLevel}</td>
                    </tr>
                    {!!userDisability.approvedOn && (
                      <tr>
                        <th scope="row" className="p-2">
                          Approved on
                        </th>
                        <td className="p-2">
                          {moment(userDisability.approvedOn).format("LL")}
                        </td>
                      </tr>
                    )}
                    {!!userDisability.approverName && (
                      <tr>
                        <th scope="row" className="p-2">
                          Approved by
                        </th>
                        <td className="p-2">{userDisability.approverName}</td>
                      </tr>
                    )}
                    <tr>
                      <th scope="row" className="p-2">
                        Status
                      </th>
                      <td className="p-2">
                        {" "}
                        <span
                          className={`badge badge-${
                            +userDisability?.isApproved === 0
                              ? "warning"
                              : +userDisability?.isApproved === 1
                              ? "success"
                              : "danger"
                          } p-1`}
                        >
                          {+userDisability?.isApproved === 0
                            ? "Pending"
                            : +userDisability?.isApproved === 1
                            ? "Approved"
                            : "Rejected"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" className="p-2">
                        Attachment
                      </th>
                      <td className="p-2">
                        {!userDisability?.docReferenceId && (
                          <>
                            <div
                              className="card  w-100"
                              style={{
                                backgroundColor: "#fff",
                                borderLeft: "2px solid #3f51b5",
                                borderLeft: "2px solid #3f51b5",
                                borderRadius: "4px",
                              }}
                            >
                              <div className="card-body w-100">
                                <p className="small p-0 ms-2 mb-0 rounded-3">
                                  No document was uploaded in IPPIS.
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                        {!!userDisability?.docReferenceId && (
                          <>
                            <Chip
                              avatar={<Avatar alt={"Attachment"} src={pdf} />}
                              style={{ marginTop: "5px" }}
                              size="small"
                              onClick={() => {
                                setOnViewDocument(true);
                                setDocument(userDisability);
                              }}
                              label={
                                <>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#0d141d",
                                      fontWeight: "600",
                                      width: "calc(100% - 80px)",
                                      overflow: "hidden",
                                      textDecoration: "none",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                    className="text-truncate text-lowercase"
                                  >
                                    View attached document
                                  </span>
                                </>
                              }
                              variant="outlined"
                              color="primary"
                              deleteIcon={<CloudDownloadIcon />}
                              onDelete={() => {
                                setOnViewDocument(true);
                                setDocument(userDisability);
                              }}
                            />

                            {onViewDocument && document && (
                              <PreviewPdfUrl
                                showDocument={onViewDocument}
                                setShowDocument={() => setOnViewDocument(false)}
                                document={{
                                  name: `View attached document`,
                                  url:
                                    process.env.REACT_APP_FILES_URL +
                                    "/preview/" +
                                    document.docReferenceId,
                                }}
                              />
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  </thead>
                </table>
              </>
            }
            setConfirmationDialog={setShowModal}
            onYes={() => {
              approveDisability(
                userDisability,
                { statusId: 1 },
                setShowModal
              );
            }}
            onDecline={() => {
              approveDisability(
                userDisability,
                { statusId: 0 },
                setShowModal
              );
            }}
          />
        )}
      </tr>
    </>
  );
};
